"use client"

import { Button } from "@/elements"
import { InviteToAJobDialog } from "@/components/InviteToJobDialog"
import { FragmentType, useFragment } from "@/gql"
import { ConnectOrMessageButton } from "@/components/ConnectOrMessageButton"
import type { NovaSession } from "@/types"
import { PortfolioUIState } from "../page"
import { PostAProjectButton } from "./PostAProjectButton"
import { ActionsModal } from "./ActionsModal"
import { HeaderActionButtonsFragmentDoc, UserConnectionStatus } from "@/gql/graphql"
import { useEditPortfolio } from "./edit/useEditPortfolio"

interface Props {
  creative: FragmentType<typeof HeaderActionButtonsFragmentDoc> | undefined | null
  serverSession: NovaSession | null
  uiState: PortfolioUIState
  editProfileMethods?: ReturnType<typeof useEditPortfolio>
}

export const HeaderActionButtonsMobile: React.FC<Props> = props => {
  const { serverSession, uiState, editProfileMethods } = props
  const creative = useFragment(HeaderActionButtonsFragmentDoc, props.creative)
  const user = creative?.user
  const viewerConnectionStatus = user?.viewerConnectionStatus

  if (editProfileMethods?.isEditing) return null

  return (
    <div className="mt-6 flex h-full flex-1 flex-row gap-2">
      {uiState?.isUsersPortfolio && !editProfileMethods?.isEditing && (
        <div className="flex flex-1">
          <PostAProjectButton
            viewerCreativeHandle={creative?.handle!}
            className="flex flex-1"
            entryPoint="portfolio_header"
          />
        </div>
      )}
      {serverSession && !uiState?.isUsersPortfolio && (
        <div className="flex flex-1">
          <ConnectOrMessageButton
            fillSpace
            trackingEntryPoint="portfolio-main-header"
            user={creative?.user}
            serverSession={serverSession}
            className="flex w-full flex-1"
            layout="row"
          />
        </div>
      )}
      {!uiState?.isUsersPortfolio && viewerConnectionStatus !== UserConnectionStatus.ConnectionRequestReceived && (
        <div className="flex flex-1">
          <InviteToAJobDialog
            trackingEntryPoint="portfolio-main-header"
            creative={creative}
            triggerWrapperClassName="flex flex-1"
            trigger={
              <Button className="flex flex-1" variant="grey-outline">
                Invite to Job
              </Button>
            }
          />
        </div>
      )}
      {!uiState?.isUsersPortfolio && <ActionsModal user={creative?.user} isCreative serverSession={serverSession} />}
    </div>
  )
}
